export default "__VITE_ASSET__BJXYd_qd__"